<template>
    <nuxt-link
        v-bind="$attrs"
        class="close-button"
    >
        <BaseIcon
            class="close-button__icon dn-icon--square"
            icon="close"
        />
        <span class="close-button__text">
            <slot />
        </span>
    </nuxt-link>
</template>

<script setup lang="ts">
</script>
<style lang="less">
.close-button {
    .typography-label-secondary;

    display: flex;
    padding: 0.375rem;
    justify-content: center;
    align-items: center;
    gap: 0.625rem;
    margin-left: auto;

    text-decoration: none;
    transition: color var(--transition-fast);

    &:hover, &:focus {
        color: var(--color-primary);
        cursor: pointer;
    }

    &:active {
        color: var(--color-primary-dark);
    }
}

.dn-icon.close-button__icon {
    flex: 0 0 auto;
    font-size: 1.125rem;
    line-height: 0;
    transform: translateX(0);
    transition: transform var(--transition-fast);

    .close-button:hover & {
        transform: scale(0.95);
    }
}

.close-button__text {
    line-height: 1;
    position: relative;
    font-size: 1.125rem;
}
</style>
